import * as React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import { DialogImage } from '../SEPlayTypes';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

type SEPlayEditImagesProps = {
    image: DialogImage;
    title: number;
    handleUpdateImage: any;
    tooltipLabel: string;
    dragTooltip: string;
};

let StyledImageFooter = styled(Box)(({ theme }) => ({
    padding: '5px 0',
    textAlign: 'center',
    maxWidth: '71px',
    margin: 'auto'
}));

const SEPlayEditDialogListItem = (props: SEPlayEditImagesProps) => {
    let { image, title, handleUpdateImage, tooltipLabel, dragTooltip } = props;

    const [titleIsHovered, setTitleIsHovered] = React.useState(false);

    const handleMouseOver = () => {
        setTitleIsHovered(true);
    };

    const handleMouseOut = () => {
        setTitleIsHovered(false);
    };

    return (
        <List
            key={image.thumbnail}
            sx={{
                height: '140px',
                padding: '0'
            }}
        >
            <Box
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
                sx={{
                    borderRadius: '4px',
                    marginRight: '24px',
                    '&:hover': {
                        backgroundColor: 'rgba(125, 171, 155, 0.5)',
                        cursor: 'move'
                    }
                }}
            >
                <Box sx={{
                    position: 'relative',
                }}>
                    <img
                        draggable='false'
                        width="auto"
                        height="107px"
                        src={image.thumbnail}
                        alt={`slideshow-image-${image.reference}`}
                        className={'seplay-editing-imagelist-image'}
                    />
                    <Tooltip
                        className='dragged-hide'
                        title={tooltipLabel}
                        componentsProps={{ tooltip: { sx: { fontSize: '14px' } } }}
                    >
                        <Button
                            aria-label={'delete-image-button'}
                            sx={{
                                minWidth: '0px',
                                position: 'absolute',
                                right: '3%',
                                top: '3%',
                                color: 'rgba(0, 0, 0, 0.87)',
                                padding: '2px',
                                margin: 0,
                                borderRadius: '9px',
                                backgroundColor: 'white',
                                width: '17px',
                                height: '17px'
                            }}
                            onClick={handleUpdateImage}
                        >
                            <CloseIcon sx={{ height: '10px', width: '10px' }} />
                        </Button>
                    </Tooltip>
                </Box>
                <StyledImageFooter 
                    className='dragged-hide'>
                    <Typography sx={{ lineHeight: '15px' }}>
                        {!titleIsHovered ? title : dragTooltip}
                    </Typography>
                </StyledImageFooter>
            </Box>
        </List>
    );
};

export default SEPlayEditDialogListItem;
